import BaseListPresenter from "../../../../base/BaseListPresenter";

class MonetizationHrddPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    const getcurrent = this.view.getcurrent();
    this.limit = 10;
    this.where = {
      $or: [
        { stats: "For HRMS Processing" },
        { stats: "Approved" },
        { stats: "Cancel Request" },
        { stats: "Disapproved" },
      ],
    };
    this.search = {};
    this.filter = {};
    this.include = [
      "employee",
      "employee.position",
      "employee.salaryPointer",
      "leaveType",
    ];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }
}
export default MonetizationHrddPresenter;
